<script>
	export let layers = ""; // string like "a, b, c"
	export let styles = ""; // string like "x; , y; , z;"
	export let baseClass = "pointer-events-none"; // optional
	export let tag = "div"; // if you ever want span, etc.

	const splitLayers = (value) => (value || "").split(", ")?.filter(Boolean);

	const splitStyles = (value) => {
		return value?.split(", ")?.filter(Boolean);
	};

	$: layerAry = splitLayers(layers) || [];
	$: styleAry = splitStyles(styles) || [];
	$: pairedLayers = layerAry.map((layer, index) => ({
		layer,
		style: styleAry[index] || "",
	}));
</script>

{#each pairedLayers as entry}
	<svelte:element
		this={tag}
		aria-hidden="true"
		class={`${baseClass} ${entry.layer}`}
		style={entry.style}
	></svelte:element>
{/each}
